import { AsyncPipe, DatePipe, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleMap, MapCircle, MapMarker, MapPolygon, MapPolyline } from '@angular/google-maps';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { MapSearchAddressComponent } from './components/map-search-address/map-search-address.component';
import { NewFarmComponent } from './components/new-farm/new-farm.component';
import { SavedFarmsComponent } from './components/saved-farms/saved-farms.component';
import { HomePageRoutingModule } from './home-routing.module';
import { HomePageComponent } from './home.page';

@NgModule({
  declarations: [HomePageComponent, SavedFarmsComponent, NewFarmComponent, MapSearchAddressComponent],
  imports: [
    GoogleMap,
    IonicModule,
    HomePageRoutingModule,
    MapCircle,
    MapPolygon,
    MapPolyline,
    MiscModule,
    DatePipe,
    AsyncPipe,
    MapMarker,
    NgTemplateOutlet
  ]
})
export class HomePageModule {}
